<template>
  <div class="wrap">
    <div class="page404">
      <div class="e404"></div>
      <div class="error-tips">
        <p>{{ $t('页面访问错误_请稍后访问___') }}</p>
        <a :href="overviewLink" class="blueLink f14">{{
          $t('前往概览页__')
        }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sk-error-page',
  data() {
    return {
      overviewLink: '//console.jdcloud.com'
    }
  }
}
</script>
<style scoped>
.wrap {
  width: 1200px;
  margin: 0 auto;
}
.f14 {
  font-size: 14px;
}
.blueLink {
  color: #2aafff;
}
.blueLink:hover {
  color: #51d2b7;
}
.page404 {
  padding: 130px 0 240px 220px;
  margin-bottom: 50px;
  background: url(./images/404bg.png) no-repeat center bottom;
}
.e404 {
  width: 215px;
  height: 82px;
  background: url(./images/404.png) no-repeat;
}
.error-tips p {
  padding: 40px 0 20px;
  font-size: 16px;
}
</style>
